const NotFound = () => {
  return <>NotFound</>;
};

export default NotFound;
